<template>
  <div class="container py-5">
    <h1 class="display-6 text-center">Educational Technology (EdTech)</h1>
  <!-- Intro Section -->
    <div class="lead text-center mb-5">
    Exploring research-informed teaching strategies, digital pedagogy, learning frameworks, and emerging technologies that enhance Computer Science education and support engaging, inclusive, and future-ready learning experiences.
    </div>
   
  </div>
   <!-- Render InfoButtons only on tab 2 -->
  <div class="card border-0 shadow-sm mb-5 p-4">
    <h5 class="text-success">Exploring and Applying Learning Models (under development - coming soon!)</h5>
    <p class="mb-3">
      Making teaching and learning more engaging 
    </p>
    <ul class="list-group list-group-flush">
      <li class="list-group-item"><strong>SAMR</strong></li>
      <li class="list-group-item"><strong>TPACK</strong></li>
      <li class="list-group-item"><strong>UDL</strong></li>
      <li class="list-group-item"><strong>Bloom's Taxonomy</strong></li>
    </ul>
  </div>

         
</template>



<style scoped>
.nav-link {
  cursor: pointer;
}
.card-title {
  font-weight: 600;
}
.nav-link {
  background-color: #f8f9fa !important;
  color: #000 !important;
  border: 1px solid #dee2e6 !important;
}

.nav-link:hover {
  background-color: #e9f5ee !important;
  color: #000 !important;
}


.nav-link.active {
  background-color: #198754 !important;
  color: #fff !important;
  border-color: #198754 !important;
  font-weight: 600;
}

.bg-image-1 {
  background-image: url('@/assets/images/slider/linux_mental_model_1.png'); /* Replace with your image */
}





</style>
